<script setup lang="ts">
import { computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Skeleton from '@/components/Skeleton.vue'
import Sidebar from '@/components/Sidebar.vue'
import StudentQuestionReview from '@/components/Questions/StudentQuestionReview.vue'
import GroupQuestionReview from '@/components/Questions/GroupQuestionReview.vue'
import { groupModule } from '@/store/group/module'

const route = useRoute()
const router = useRouter()

const showStudentQuestionReview = computed(() => {
    return route.matched.some(r => r.name === 'student-stats') && !!route.query.questionSerial
})

const showGroupQuestionReview = computed(() => {
    return route.matched.some(r => r.name === 'group-stats') && !!route.query.questionSerial
})

const closeQuestionReview = () => {
    router.push({
        name: route.name as string,
        params: { ...route.params },
    })
}

watch(() => route.name,
    (name) => {
        if (name !== 'stats') {
            return
        }
        const group = groupModule.getters.getCurrentGroup() ? groupModule.getters.getCurrentVisibleOrgGroups()[0] : null
        if (group) {
            router.replace({ name: 'group-stats', params: { groupId: group.objectId } })
        }
    }
)
</script>

<template>
    <div class="stats-wrapper">
        <Skeleton class="stats">
            <template #side>
                <Sidebar />
            </template>
            <RouterView />
        </Skeleton>
        <StudentQuestionReview
            v-if="showStudentQuestionReview"
            @close="closeQuestionReview"
        />
        <GroupQuestionReview
            v-if="showGroupQuestionReview"
            @close="closeQuestionReview"
        />
    </div>
</template>

<style lang="scss" scoped>
.stats-wrapper {
    position: relative;
    height: 100%;
    width: 100%;
}
</style>
